import Carousel from "components/Carousel"
import { FieldLabel, FieldLabelAndValue } from "components/Fields/styled"
import Image from "components/Image"
import ImageSelector from "components/ImageSelector"

import { ComponentProps } from "."
import { Wrapper } from "./styled"

const ImageSelectorAndCarousel = ({
  imageSelectorProps,
  images,
  isEditMode,
  mediaLabel,
  selectedImages
}: ComponentProps) => {
  const label = mediaLabel ?? "Images"

  return (
    <Wrapper>
      {isEditMode ? (
        <ImageSelector {...imageSelectorProps} mediaLabel={label} />
      ) : null}

      {isEditMode ? (
        <Carousel name={`${label} Editing`} slidesToShow={3}>
          {selectedImages
            .filter(({ originalUrl }) => originalUrl)
            .map(({ id, originalUrl }) => (
              <Image
                {...{
                  formats: {},
                  filename: `${originalUrl ?? ""}-${id}`,
                  url: originalUrl ?? ""
                }}
                key={id}
              />
            ))}
        </Carousel>
      ) : (
        <FieldLabelAndValue>
          <FieldLabel>{label}</FieldLabel>

          <Carousel name={label} slidesToShow={3}>
            {images?.map((image) => (
              <Image {...image} key={image.id} />
            ))}
          </Carousel>
        </FieldLabelAndValue>
      )}
    </Wrapper>
  )
}

export default ImageSelectorAndCarousel
